module.exports = __webpack_public_path__ + "img/magento-setup-tuning@2x.a781e7a7.jpeg";